import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import {
    Card,
    Box, Container, Typography, TableHead, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, Paper, MenuItem,
    FormControl, Snackbar, Alert,
    Select, InputLabel, Dialog, DialogTitle, ListItem, List, DialogContent, DialogActions, Button, Grid, Toolbar, Tab, Tabs, Fab, useMediaQuery, TextField, Link, Divider
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { userList } from '../../services/UserService';
import { setTimeoutsecs, pBtn, setAutoHideDurationTimeoutsecs, PerChk, TPA } from '../../common/Common';
import { ExpDetailslist } from '../../services/Experience';
import 'react-quill/dist/quill.snow.css';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import ReactQuill from 'react-quill';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import CircleIcon from '@mui/icons-material/Circle';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
import { AddExp } from '../../services/Experience';
import { mainTheme } from '../../core/TabsCore';
import { Info } from '@mui/icons-material';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable() {
    const [open, setOpen] = useState(false);
    const [page, setPage] = React.useState(0);
    const [expList, setExpList] = useState([]);
    const [userData, setUserData] = React.useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState('All');
    const [selectedRow, setSelectedRow] = useState(null);
    const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
    const [fullContent, setFullContent] = useState('');
    const [expanded, setExpanded] = useState(false);
    const userId = sessionStorage.getItem('userId');

    const handleAddIconClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function ShareExperienceComponent() {
        const [loading, setLoading] = useState(false);
        const [submitAlert, setSubmitAlert] = useState(false);
        const [submitFailed, setSubmitFailed] = useState('');
        const [valueData, setValue] = useState('');
        const visibilitydata = ['Members', 'Public'];
        const quill = useRef();
        const [decodedHtml, setDecodedHtml] = useState('');
        const userId = sessionStorage.getItem('userId');
        const [title, setTitle] = useState('');
        const [visibility, setVisibility] = useState('Members');
        const disableaddSubmitbutton = !visibilitydata || !title || !valueData;

        const formats = [
            "header",
            "bold",
            "italic",
            "underline",
            "strike",
            "blockquote",
            "list",
            "bullet",
            "indent",
            "link",
            "color",
            "image",
            "clean",
        ];

        const handleSubmit = async () => {
            const encodedContent = encodeURIComponent(valueData);
            const base64EncodedContent = btoa(encodedContent);
            setLoading(true);
            try {
                let data = {
                    experience_title: title.trim(),
                    experience_summary: base64EncodedContent,
                    experience_status: 'Pending',
                    experience_createdby: userId,
                    visibility: visibility
                }
                let resp = await AddExp(data);
                setSubmitAlert(true);
                if (resp) {
                    setTimeout(() => {
                        setLoading(false);
                        setOpen(false);
                        userDatalist();
                        ExpDataList();
                        // setSubmitAlert(false);
                    }, setTimeoutsecs);
                }
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    setSubmitFailed(error.response.data.message);
                    setSubmitAlert(true);
                }
                else {
                    console.log("An unexpected error occurred:", error.message);
                    setSubmitFailed('Experience submission failed');
                    setSubmitAlert(true);
                } setTimeout(() => {
                    setLoading(false);
                    // setOpen(false);
                    // userDatalist();
                    // ExpDataList();
                    setSubmitAlert(false);
                }, setAutoHideDurationTimeoutsecs);
            }
        }

        const modules = useMemo(
            () => ({
                toolbar: {
                    container: [
                        [{ header: [1, 2, 3, 4, false] }],
                        ["bold", "italic", "underline", "blockquote"],
                        [{ color: [] }],
                        [
                            { list: "ordered" },
                            { list: "bullet" },
                            { indent: "-1" },
                            { indent: "+1" },
                        ],
                        ["link", "image"],
                        ["clean"],
                    ],
                },
                clipboard: {
                    matchVisual: true,
                },
            }),
            []
        );


        return (<>
            <Dialog fullWidth maxWidth='lg' open={open} >
                <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px', borderBottom: '2px solid #b5651d' }}>
                    <Typography component='p' variant='h6' sx={{ textTransform: 'none' }}>Share Your Experience</Typography>
                    <CloseIcon sx={{ color: 'white', bgcolor: 'red', borderRadius: '15%', cursor: 'pointer' }} onClick={(e) => setOpen(false)} />
                </DialogTitle>
                <DialogContent style={{ overflowY: 'unset' }}>
                    <Container>
                        <Box component={Grid} container spacing={2} sx={{ flexGrow: 1, p: 3 }} >
                            <Grid item sm={12}>
                                <Typography sx={{ m: '5px', mb: '20px' }}>
                                    Wish there was something you could tell your loved one? Write a message to them here.
                                </Typography>
                                <Typography sx={{ m: '5px', mb: '20px' }}>
                                    Your story could help someone else who is feeling low. Share it here.
                                </Typography>
                                <Typography sx={{ m: '5px', mb: '30px' }}>
                                    It was a really tough time. Was there something that helped you? Or did it feel like nothing ever could? Talk about what you were going through.

                                    <List>
                                        <ListItem><CircleIcon sx={{ fontSize: '65%', mr: '5px' }} />Please be mindful of the language that you use. Avoid using any statements which could be hurtful to others.</ListItem>
                                        <ListItem><CircleIcon sx={{ fontSize: '65%', mr: '5px' }} />Bringing up political, religious and other sensitive topics is not accepted.</ListItem>
                                        <ListItem><CircleIcon sx={{ fontSize: '65%', mr: '5px' }} />SNEHA – SAS reserves the right to pull down submissions which do not adhere to these standards.</ListItem>
                                        <ListItem><CircleIcon sx={{ fontSize: '65%', mr: '5px' }} />The submissions shall be pulled down after a certain period of time.</ListItem>
                                    </List>
                                </Typography>
                            </Grid>
                            <Grid item sm={6}><TextField required label="Title" value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            /></Grid>
                            <Grid item sm={6}><TextField select required label="Visibility" value={visibility}
                                onChange={(e) => setVisibility(e.target.value)}>
                                {visibilitydata.map((option) => (<MenuItem key={option} value={option}>{option}</MenuItem>))}</TextField>
                            </Grid>
                        </Box>
                        <ReactQuill
                            ref={(el) => (quill.current = el)}
                            className="ql-container ql-snow"
                            value={valueData}
                            formats={formats}
                            modules={modules}
                            onChange={(content) => setValue(content)} />
                        <small><Info /> <b>The size of images shouldn't exceed 256 kB</b></small>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Button type="submit" disabled={disableaddSubmitbutton || loading}
                        variant="contained"
                        sx={pBtn} onClick={handleSubmit}>Save{loading ? <CircularProgress /> : null}</Button>
                </DialogActions>
                {submitFailed ? <Snackbar
                    open={submitAlert}
                    autoHideDuration={setAutoHideDurationTimeoutsecs}
                >
                    <Alert
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {submitFailed}
                    </Alert>
                </Snackbar> : <Snackbar
                    open={submitAlert}
                    autoHideDuration={setAutoHideDurationTimeoutsecs}
                >
                    <Alert
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        Experience submitted
                    </Alert>
                </Snackbar>}

            </Dialog>
        </>)
    }


    useEffect(() => {
        if (selectedRow) {
            const base64Decoded = atob(selectedRow.experience_summary);
            const decodedHTML = decodeURIComponent(base64Decoded);
            setFullContent(decodedHTML);
        }
    }, [selectedRow]);

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setExpanded(true);
    };

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - expList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleChangeStatusFilter = (event) => {
        setStatusFilter(event.target.value);
        setPage(0); // Reset page when filter changes
    };
    const ExpDataList = async () => {
        try {
            let resp = await ExpDetailslist();
            const filteredList = resp.result.filter(x => x.experience_createdby === userId);
            setExpList(filteredList.reverse())
        } catch (error) {

            console.log(error)
        }
    };

    const userDatalist = async () => {
        try {
            let resp = await userList();
            setUserData(resp.result.filter(x => x._id == userId));
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            await userDatalist();
            await ExpDataList();
        };

        if (isMounted) {
            fetchData();
        }

        return () => {
            isMounted = false;
        };
    }, []);

    const filteredData = expList.filter(user => {
        const matchesSearchQuery = Object.values(user).some(value => {
            if (typeof value === 'string') {
                return value.toLowerCase().includes(searchQuery.toLowerCase());
            }
            return false;
        });

        const statusMatches = statusFilter === 'All' || user.experience_status === statusFilter;

        return matchesSearchQuery && statusMatches;
    });
    const nonMobileStyles = {
        flexGrow: 1,
        p: 3,
    };

    const getUserExpObj = (id) => {
        let obj = userData.filter(x => x._id == id)[0];
        return obj;
    }


    return (<ThemeProvider theme={mainTheme}><Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Container component="main" sx={{ width: '80vw' }}>

            <Box sx={{ mb: '20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'stretch' : null }}>
                    <FormControl sx={{ minWidth: '125px' }}>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            value={statusFilter}
                            onChange={handleChangeStatusFilter}
                            label="Status"
                        >
                            <MenuItem value="All">All</MenuItem>
                            <MenuItem value="Published">Published</MenuItem>
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="Rejected">Rejected</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl sx={{ width: '130px' }}>
                        <TextField
                            label="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            variant="outlined"
                            size="small"
                        />
                    </FormControl>
                </Box >

            </Box>
            {filteredData.length > 0 ?
                < Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table>
                            <TableHead sx={{ bgcolor: '#a5644e', position: 'sticky', top: 0, zIndex: 100 }}>
                                <TableRow sx={{ alignItems: 'center' }}>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Title</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                                    <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Visible</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(rowsPerPage > 0
                                    ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : filteredData
                                ).map((row) => (
                                    <TableRow key={row._id} onClick={() => handleRowClick(row)}
                                        sx={{
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#fcf2e7',
                                            },
                                        }}>
                                        <TableCell sx={{ textTransform: 'none' }} component="th" scope="row">
                                            {row.experience_title}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                textTransform: 'none',
                                                color:
                                                    row.experience_status === 'Published'
                                                        ? 'green'
                                                        : row.experience_status === 'Rejected'
                                                            ? 'red'
                                                            : row.experience_status === 'Pending' ? 'darkblue'
                                                                : '#d3d3d3',
                                            }}
                                            component="th"
                                            scope="row"
                                        >
                                            {statusFilter === 'All' || row.experience_status === statusFilter ? row.experience_status : ''}
                                        </TableCell>
                                        <TableCell sx={{ textTransform: 'none' }} component="th" scope="row">
                                            {row.visibility}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {/* {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )} */}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={filteredData.length}
                                        page={page} rowsPerPage={rowsPerPage}
                                        sx={{ '.MuiTablePagination-displayedRows': { display: 'none' } }}
                                        onPageChange={(e, p) => { setPage(p) }} rowsPerPageOptions={[]}
                                        ActionsComponent={TPA}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer> </Paper> : <Typography variant='h6' sx={{ textAlign: 'center' }}>No records</Typography>}
        </Container>
        {selectedRow &&
            <Dialog fullWidth maxWidth='lg' open={expanded}  >
                <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px', borderBottom: '2px solid #b5651d' }}>
                    <Typography component='p' variant='h6' sx={{ textTransform: 'none' }}>{selectedRow.experience_title}</Typography>
                    <CloseIcon sx={{ color: 'white', bgcolor: 'red', borderRadius: '15%', cursor: 'pointer' }} onClick={(e) => setExpanded(false)} />
                </DialogTitle>
                <DialogContent>
                    <Card sx={{ marginTop: '10px' }}>
                        <Typography className="ql-editor" dangerouslySetInnerHTML={{ __html: fullContent }}></Typography>
                    </Card>
                </DialogContent>
            </Dialog>
        }
        <Fab hidden={PerChk('ADD_EXPERIENCE')} sx={{ position: 'fixed', bottom: 40, right: 20 }} onClick={handleAddIconClick}>
            <AddIcon sx={{ color: '#fff' }} />
        </Fab>
        <ShareExperienceComponent onClose={handleClose} />
    </Box>
    </ThemeProvider>
    );
}









